import type { Column } from '@/components/Organisms/DataTable/DataTable.types';
import { colors } from '@/components/ui/theme';

/**
 * Order Return Status code mapping with colors (NEW status system)
 */
const ORDER_RETURN_STATUS_MAP: Record<number, { label: string; color: string }> = {
	953870000: { label: 'In Process', color: colors.pendingYellow }, // TOR Form Sent To Clinic
	953870001: { label: 'In Process', color: colors.pendingYellow }, // Shipping Label Request
	953870002: { label: 'In Process', color: colors.pendingYellow }, // Shipping Label Complete
	953870003: { label: 'In Process', color: colors.pendingYellow }, // Pending Product Receipt
	953870004: { label: 'Product Received', color: colors.primary },
	953870005: { label: 'Return Complete', color: colors.success },
	953870006: { label: 'Closed', color: colors.defaultGray },
};

/**
 * Maps Order Return status code to status object with label and color
 * @param statusCode - The status code from data
 * @returns Object with label and color, or default values
 */
export const getOrderReturnStatus = (
	statusCode: number,
): { label: string; color: string } => {
	return ORDER_RETURN_STATUS_MAP[statusCode] || { label: 'In Process', color: colors.pendingYellow };
};

// Status filter options (NEW status system)
export const statusFilterOptions = [
	{ label: 'All', value: '' },
	{ label: 'In Process', value: "processing" },
	{ label: 'Product Received', value: 953870004 },
	{ label: 'Return Complete', value: 953870005 },
	{ label: 'Closed', value: 953870006 },
];

// Columns matching the backend entity field names with smart spacing
export const columns: Column[] = [
	{
		key: 'ta_expirationdate',
		label: 'Expiry Date',
		width: '120px',
		type: 'date',
		dateISO: true,
		sorter: true,
	},
	{
		key: 'ta_datereturnedtransferred',
		label: 'Returned Date',
		width: '120px',
		type: 'date',
		dateISO: true,
		sorter: true,
	},
	{
		key: 'ta_newshippingdaterequested',
		label: 'New Shipping Date',
		width: '120px',
		type: 'date',
		dateISO: true,
		sorter: true,
	},
	{
		key: 'product.ta_name',
		label: 'Product',
		width: '150px',
		type: 'string',
		sorter: true,
	},
	// { // aoun feed back just commenting it for now
	// 	key: 'qty',
	// 	label: 'Qty',
	// 	width: '80px',
	// 	type: 'number',
	// 	sorter: true,
	// },
	{
		key: 'shipping_location',
		label: 'Shipping Location',
		width: '180px',
		type: 'string',
		sorter: true,
	},
	{
		key: 'clinic.name',
		label: 'Clinic',
		width: '160px',
		type: 'string',
		sorter: true,
	},
	{
		key: 'ta_status',
		label: 'Status',
		width: '180px',
		type: 'string-status',
		sorter: false,
		filterOptions: statusFilterOptions,
	},
];
